import { render, staticRenderFns } from "./Procedure.vue?vue&type=template&id=b580dc2e&scoped=true&"
import script from "./Procedure.vue?vue&type=script&lang=js&"
export * from "./Procedure.vue?vue&type=script&lang=js&"
import style0 from "./Procedure.vue?vue&type=style&index=0&id=b580dc2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b580dc2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
